import BasicMenu from "components/MenuDropdown/BasicMenu";
import { useEffect, useMemo, useState } from "react";
import { Button, Card, Col, Container, Row, Table } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import CreateChildBagModal from "./ChildBag/CreateChildBagModal";
import { useDispatch, useSelector } from "react-redux";
import { fetchGRNDetails } from "slices/Warehouse/ItemInward2/GRN/thunk";
import {
  DynamicMenuItem,
  MenuItemConfig,
} from "components/Menuitem/DynamicMenuItem";
import LocalMallIcon from "@mui/icons-material/LocalMall";
import QrCodeIcon from "@mui/icons-material/QrCode";
import BagQRPrint from "./BagQRPrint/BagQRPrint";
import FilePreviewModal from "./FilePreviewModal/FilePreviewModal";
import { tableStyles } from "Constants/Style";
import LoadingSpinner from "components/LoaderErrorWrapper/LoadingSpinner";
import PageContainer from "components/PageContainer/PageContainer";
import FormHeader from "components/Form&DetailsHeader/Form&DetailsHeader";
import CancelBackButton from "components/Buttons/CancelBackButton";
import TruncatedTextCell from "components/TruncatedTextCell/TruncatedTextCell";

const LabourInwardItemDetails = ({ type }: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch<any>();
  const { id } = useParams<{ id: string }>();
  const [showModal, setShowModal] = useState(false);
  const [newItems, setNewItems] = useState<any>([]);
  const [labourItems, setLabourItems] = useState<any>([]);
  const [showPreview, setShowPreview] = useState(false);
  // const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [showQRPrint, setShowQRPrint] = useState(false);
  const [qrPrintItem, setQrPrintItem] = useState<any>(null);
  const { details, loading } = useSelector((state: any) => state.grn);

  useEffect(() => {
    console.log("Details", details);
    console.log("Labour Items", labourItems);
    console.log("New Items", newItems);
  }, [details, labourItems, newItems]);

  // useEffect(() => {
  //     if (id) {
  //       dispatch(fetchGRNDetails(id as string) as any);
  //     }
  // }, [dispatch, id]);

  useEffect(() => {
    // Set all inventory items (both new and returned) for the first table
    if (details?.inventory_items) {
      setNewItems(details.inventory_items);
    }

    // Set dispatch_items for the second table (Issued Items)
    if (details?.dispatch?.dispatch_items) {
      setLabourItems(details.dispatch.dispatch_items);
    }
  }, [details]);

  const handleOpen = (item: any) => {
    setSelectedItem(item);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedItem(null);
  };

  const menuItems: MenuItemConfig[] = useMemo(() => {
    const items: MenuItemConfig[] = [
      {
        icon: LocalMallIcon,
        label: "Create Child Bag",
        permission: true,
        onClick: (item: any) => {
          handleOpen(item);
        },
        color: "primary",
      },
      {
        icon: QrCodeIcon,
        label: "Print QR",
        permission: true,
        onClick: (item: any) => {
          setQrPrintItem(item);
          setShowQRPrint(true);
        },
        color: "info",
      },
    ];
    return items;
  }, []);

  return (
    <PageContainer>
      <FormHeader
        title="Inward Details (Labour)"
        firstLabel="GRN"
        secondLabel="Inward Details"
        handleArrowClick={() => navigate("/warehouse-item-inward")}
      />

      {loading ? (
        <LoadingSpinner />
      ) : (
        <Card.Body>
          <style>
            {`
          .sticky-column {
            width: 40px;
            position: sticky;
            right: 0;
            z-index: 1;
            background-color: #fff !important;
            border-left: 1px solid #dee2e6;
            text-align: center;
          }
          thead .sticky-column {
            background-color: #EEF0F7 !important;
          }
          .sticky-action {
            box-shadow: -4px 0 6px rgba(0, 0, 0, 0.1);
          }
          .table td,
          .table th {
            background-clip: padding-box;
          }
          .remark-cell {
            max-width: 300px;
            white-space: normal !important;
            word-wrap: break-word;
            overflow-wrap: break-word;
          }

        `}
          </style>

          <>
          <hr />
            <Row className="mb-2">
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>GRN No. :</strong> {details?.grn_no || "-"}
                </p>
              </Col>
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Dispatch ID :</strong>{" "}
                  {details?.dispatch?.dispatch_number || "-"}
                </p>
              </Col>
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Inward Date :</strong>{" "}
                  {details?.inward_date
                    ? new Date(details?.inward_date).toISOString().split("T")[0]
                    : "-"}
                </p>
              </Col>
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Labour Name :</strong>{" "}
                  {details?.dispatch?.labour_name || "-"}
                </p>
              </Col>

              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Received By :</strong>{" "}
                  {`${details?.received_by_details?.first_name} ${details?.received_by_details?.last_name}` ||
                    "-"}
                </p>
              </Col>
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Remark :</strong> {details?.remarks || "-"}
                </p>
              </Col>
              <Col xs={12} md={6} lg={4}>
                <p className="mb-3">
                  <strong>Document :</strong>{" "}
                  {details?.document_file ? (
                    <button
                      onClick={() => setShowPreview(true)}
                      style={{
                        color: "blue",
                        cursor: "pointer",
                        background: "none",
                        border: "none",
                        padding: 0,
                        textDecoration: "underline",
                      }}
                    >
                      View
                    </button>
                  ) : (
                    "-"
                  )}
                </p>
              </Col>
              {/* Document Viewer Popup */}
              <FilePreviewModal
                show={showPreview}
                onClose={() => setShowPreview(false)}
                url={details?.document_file}
              />
            </Row>

            {/* New Items */}
            <div className="mb-3 mt-3" style={{ overflowX: "auto" }}>
              <h6 className="card-title mb-3">Received Items</h6>
              <Table hover responsive className="align-middle text-center">
                <thead>
                  <tr>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "70px",
                      }}
                    >
                      Sr No.
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Item Name
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Item Code
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Category
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Sub Category
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Unit
                    </th>
                    {/* <th style={{ minWidth: "150px" }}>Issue Quantity</th> */}
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Item Type
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "150px",
                      }}
                    >
                      Received Quantity
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Bag No.
                    </th>
                    {/* <th style={{ minWidth: "120px" }}>Bag No.</th>
                        <th style={{ minWidth: "120px" }}>Rate</th>
                        <th style={{ minWidth: "120px" }}>Amount</th> */}
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "100px",
                      }}
                    >
                      Remark
                    </th>
                    <th
                      // className="sticky-column"
                      style={{
                        ...tableStyles.headerAlt,
                        ...tableStyles.actionHeader,
                        minWidth: "100px",
                      }}
                    >
                      Action
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {newItems.map((item: any, idx: number) => (
                    <tr key={item.inventory_item_id}>
                      <td style={tableStyles.cell}>{idx + 1}</td>
                      <td style={tableStyles.cell}>
                        {item?.master_item?.item_name || "-"}
                      </td>
                      <td style={tableStyles.cell}>
                        {item?.master_item?.item_code || "-"}
                      </td>
                      <td style={tableStyles.cell}>
                        {item?.master_item?.category?.category_name || "-"}
                      </td>
                      <td style={tableStyles.cell}>
                        {item?.master_item?.sub_category?.sub_category_name ||
                          "-"}
                      </td>
                      <td style={tableStyles.cell}>
                        {item?.master_item?.unit?.unit_name || "-"}
                      </td>
                      <td style={tableStyles.cell}>
                        <span
                          className={`badge ${
                            item?.item_type === "new"
                              ? "bg-success"
                              : item?.item_type === "returned"
                              ? "bg-warning"
                              : "bg-secondary"
                          }`}
                        >
                          {item?.item_type === "new"
                            ? "New"
                            : item?.item_type === "returned"
                            ? "Returned"
                            : "-"}
                        </span>
                      </td>
                      {/* <td>{item.issue_quality || "-"}</td> */}
                      <td style={tableStyles.cell}>{item?.quantity || "-"}</td>
                      <td style={tableStyles.cell}>{item?.bag_no || "-"}</td>
                      {/* <td>{item.bag_no || "-"}</td> */}
                      {/* <td>{item.rate ? "Pass" : "Fail"}</td>
                            <td>{item.amount || "-"}</td> */}
                      <td className="remark-cell" style={tableStyles.cell}>
                        <TruncatedTextCell
                          text={item?.remark}
                          maxWidth="300px"
                          maxLines={4}
                          rowIndex={idx}
                          fallbackText="-"
                        />
                      </td>
                      <td
                        className="sticky-column"
                        style={tableStyles.actionCell}
                      >
                        <div style={tableStyles.actionButtonContainer}>
                          <DynamicMenuItem row={item} menuItems={menuItems} />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            {/* Issued Items */}
            <div className="my-3" style={{ overflowX: "auto" }}>
              <h6 className="card-title mb-3">Issued Items</h6>
              <Table hover responsive className="align-middle text-center">
                <thead>
                  <tr>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "80px",
                      }}
                    >
                      Sr No.
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Item Name
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Item Code
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Category
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Sub Category
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "120px",
                      }}
                    >
                      Unit
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "150px",
                      }}
                    >
                      Issue Quantity
                    </th>
                    <th
                      style={{
                        ...tableStyles.headerAlt,
                        minWidth: "100px",
                      }}
                    >
                      Remark
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {labourItems?.map((item: any, idx: number) => (
                    <tr key={item.dispatch_item_id || idx}>
                      <td className="text-center" style={tableStyles.cell}>
                        {/* {item?.sr_no || idx + 1} */}
                        {idx + 1}
                      </td>
                      <td className="text-center" style={tableStyles.cell}>
                        {item?.master_item?.item_name || item?.item_name || "-"}
                      </td>
                      <td className="text-center" style={tableStyles.cell}>
                        {item?.master_item?.item_code || item?.item_code || "-"}
                      </td>
                      <td className="text-center" style={tableStyles.cell}>
                        {item?.category?.category_name ||
                          item?.category_name ||
                          "-"}
                      </td>
                      <td className="text-center" style={tableStyles.cell}>
                        {item?.sub_category?.sub_category_name ||
                          item?.sub_category_name ||
                          "-"}
                      </td>
                      <td className="text-center" style={tableStyles.cell}>
                        {item?.unit?.unit_name || item?.unit_name || "-"}
                      </td>
                      <td className="text-center" style={tableStyles.cell}>
                        {item?.dispatch_quantity || item?.total_quantity || "-"}
                      </td>
                      <td className="remark-cell text-center" style={tableStyles.cell}>
                        <TruncatedTextCell
                          text={item?.remarks || item?.remark}
                          maxWidth="300px"
                          maxLines={4}
                          rowIndex={idx}
                          fallbackText="-"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>
            <div className="d-flex justify-content-center gap-3 py-3">
              <CancelBackButton
                label="Back"
                onClick={() => navigate("/warehouse-item-inward")}
              />
            </div>
          </>

          <CreateChildBagModal
            key={"createChildBag"}
            show={showModal}
            handleClose={handleClose}
            selectedItem={selectedItem}
            inventoryId={id}
            onSuccess={() => {
              // Refresh GRN details after successful bag creation
              if (id) {
                dispatch(fetchGRNDetails(id as string) as any);
              }
            }}
          />

          <BagQRPrint
            show={showQRPrint}
            handleClose={() => {
              setShowQRPrint(false);
              setQrPrintItem(null);
            }}
            inventoryItemId={qrPrintItem?.inventory_item_id || ""}
            bagNo={qrPrintItem?.bag_no || ""}
            autoPrint={true}
          />
        </Card.Body>
      )}
    </PageContainer>
  );
};

export default LabourInwardItemDetails;
